import { useEffect } from "react";
import classNames from "classnames";
import { Anchor, Division } from "@ir/ui";
import SidebarUserMenu from "./sidebar.user";
import SidebarBrandsMenu from "./sidebar.brands";
import SidebarCollapsableHandler from "./sidebarCollapsableHandler";
import { useHover, useMouseMoveOver, useSidebar } from "@/hooks";
import Navigation from "../navigation/navigation";
import "./styles/sidebar.scss";
import LogoCompact from "../../svg/logo-compact";
import LogoFull from "../../svg/logo-full";

const Sidebar = () => {
  const { isCollapsedSidebar, isCollapsedSidebarHovered, handleSidebarHover } = useSidebar();
  const { elementRef, isMouseInsideElement } = useMouseMoveOver();
  const { isHovered, hoverProps, forceHoverLeave } = useHover({ enterDelay: 300 });

  useEffect(() => {
    if (isCollapsedSidebar) {
      handleSidebarHover(isHovered);
    } else {
      handleSidebarHover(false);
    }
  }, [isHovered, isCollapsedSidebar, handleSidebarHover]);

  useEffect(() => {
    if (isCollapsedSidebar) {
      forceHoverLeave();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCollapsedSidebar]);

  const handleBrandsOrUserMenuOpenChange = (isOpen: boolean) => {
    if (!isOpen && !isMouseInsideElement) {
      forceHoverLeave();
    }
  };

  const sidebarHolderClass = classNames("sidebar-holder", {
    "sidebar-holder-collapsed": isCollapsedSidebar,
    "sidebar-holder-expanded": !isCollapsedSidebar,
    "sidebar-holder-active": isCollapsedSidebar && isCollapsedSidebarHovered,
  });

  const sidebarClassName = classNames(
    "sidebar",
    {
      collapse: isCollapsedSidebar,
    },
    "bg-white border-right-1 border-color-grey-25"
  );

  return (
    <aside className="sidebar-main">
      <Division className={sidebarHolderClass} ref={elementRef}>
        <Division className={sidebarClassName} {...hoverProps}>
          <Division className="sidebar-content">
            <Division data-react-aria-top-layer="true">
              <Division className="sidebar-content-logo">
                <Anchor href="/" aria-label="Home" className="flex">
                  {isCollapsedSidebar && !isCollapsedSidebarHovered ? <LogoCompact /> : <LogoFull />}
                </Anchor>
              </Division>
              <Navigation />
            </Division>

            <Division className="sidebar-content-footer" data-react-aria-top-layer="true">
              <SidebarBrandsMenu menuOpenChange={handleBrandsOrUserMenuOpenChange} />
              <SidebarUserMenu menuOpenChange={handleBrandsOrUserMenuOpenChange} />
            </Division>
          </Division>

          <SidebarCollapsableHandler showHandler={isCollapsedSidebarHovered} />
        </Division>

        <Division className="toggle-holder">
          <SidebarCollapsableHandler showHandler={!isCollapsedSidebarHovered} />
        </Division>
      </Division>
    </aside>
  );
};

export default Sidebar;
